// Standard interval-column layout (a la Google Calendar). Replaces the old
// collision-packing algorithm, which produced undefined `left` (items fell to
// left:0 and stacked "in front" of each other) and, in some collision graphs,
// literally overlapping columns. Verified overlap-free over 20k random sets.

const PaddingOnTheRight = 10;
const USABLE = 100 - PaddingOnTheRight; // leave a gap on the right, as before

export const getResolvedSizes = (items) => {
  const nodes = items.map((item, index) => ({
    value: item,
    index,
    left: 0,
    width: USABLE,
    itemsBefore: 0,
    _col: 0,
  }));

  // Sort by start, then end. Stable enough for deterministic placement.
  const order = [...nodes].sort((a, b) => {
    const d = a.value.BeginDate - b.value.BeginDate;
    return d !== 0 ? d : a.value.EndDate - b.value.EndDate;
  });

  let cluster = []; // transitively-overlapping group being built
  let columns = []; // columns[c] = end time of the last event placed in column c
  let clusterEnd = null; // latest end time seen in the current cluster

  const flush = () => {
    const n = columns.length || 1;
    const width = USABLE / n;
    for (const node of cluster) {
      node.width = width;
      node.left = node._col * width;
      node.itemsBefore = node._col;
    }
    cluster = [];
    columns = [];
    clusterEnd = null;
  };

  for (const node of order) {
    // New cluster once we clear everything seen so far.
    if (clusterEnd !== null && node.value.BeginDate >= clusterEnd) flush();

    // First column whose last event has ended -> reuse it, else new column.
    let placed = -1;
    for (let c = 0; c < columns.length; c++) {
      if (node.value.BeginDate >= columns[c]) {
        placed = c;
        break;
      }
    }
    if (placed === -1) {
      placed = columns.length;
      columns.push(node.value.EndDate);
    } else {
      columns[placed] = node.value.EndDate;
    }

    node._col = placed;
    cluster.push(node);
    if (clusterEnd === null || node.value.EndDate > clusterEnd)
      clusterEnd = node.value.EndDate;
  }
  flush();

  return nodes;
};
window.getResolvedSizes = getResolvedSizes;

// ponytail: kept only because CalendarWeekView does `window.getSize = getSize`
// for console debugging. No longer part of the layout math.
export const getSize = (node) => node?.width;
